const recap = {
	subtitle: 'Summary of your answers',
	sections: { project: 'Project', issuer: 'Issuer', services: 'Services', tourist: 'Tourist data', visuel: 'Artwork and media', devices: 'Reader devices', website: 'Website', social: 'Pass social media', inscr: 'Registrations and online shop', finance: 'Financial management', various: 'Languages, colours and other', contacts: 'Contacts', formules: 'Plans' },
	labels: {
		platform: 'Platform type:',
		tourism: 'Tourism',
		pms: 'PMS',
		nomProjet: 'Project name:',
		nomPass: 'Pass name:',
		territoire: 'Area:',
		nomComplet: 'Full name:',
		ref: 'Reference:',
		adresse: 'Address:',
		cp: 'Postal code:',
		ville: 'City:',
		pays: 'Country:',
		tel: 'Public phone:',
		site: 'Public website:',
		domaine: 'Domain:',
		emailContact: 'Public contact email:',
		emailNotif: 'Email for automatic notifications:',
		fb: 'Facebook:',
		yt: 'YouTube:',
		ig: 'Instagram:',
		x: 'X:',
		servSel: 'Selected services:',
		servOne: 'Selected service:',
		operator: 'Operator:',
		durDiff: 'Transport offer with different durations:',
		alu: 'Tourist data feed:',
		platef: 'Platform provider:',
		freq: 'Sync frequency:',
		visuel: 'Pass artwork:',
		supDem: 'Digital pass:',
		supPhys: 'Physical pass:',
		recto: 'Printed ID (front):',
		verso: 'Printed ID (back):',
		aucun: 'none',
		presta: 'Partner equipment:',
		lect: 'Read type:',
		front: 'Otipass front ordered:',
		multilang: 'Multilingual',
		langue: 'Language:',
		ndd: 'Domain name:',
		booked: 'Booked with:',
		fbPass: 'Facebook:',
		ytPass: 'YouTube:',
		igPass: 'Instagram:',
		xPass: 'X:',
		non: 'not provided',
		existingForm: 'Existing form:',
		url: 'URL:',
		existingShop: 'Existing shop:',
		non2: 'no',
		non3: 'no',
		languesBo: 'Back office languages:',
		non4: 'not set',
		primary: 'Primary brand colour:',
		non5: 'not set',
		secondary: 'Secondary colour:',
		mobile: 'Mobile app:',
		devises: 'Currencies:',
		periodE: 'Reporting (entries):',
		periodV: 'Reporting (sales):',
		non6: 'Not set',
		usable: 'Usable for {{d}} days over a rolling period of {{p}} days',
		tarifA: 'Adult price:',
		tarifE: 'Child price:',
		acc: 'Number of companions:',
		formatrix: 'Otipass registration form',
		boutique: 'Otipass shop',
		users: 'Collected user data',
		uid: 'Pivot ID (UID)',
		existing: 'Existing shop:',
		aucunC: 'No contact',
		euro: '€',
	},
	contact: {
		coordinator: 'Project lead',
		technical: 'Web integration technical contact',
		data: 'Tourist data integration contact (Apidae, Tourinsoft)',
		accounting: 'Accounting lead',
	},
	success: {
		thanks: 'Thank you for taking the time to complete this form.',
		submitted: 'Your form was submitted successfully!',
		saved: 'The data have been saved on our server.',
		printHint: 'You can now print a summary of your configuration.',
		printBtn: 'Print the summary',
	},
};

export default recap;
